import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getPublications } from '../actions/portfolioActions'
import PublicationsSection from './sections/PublicationsSection'

function PublicationsPage() {
  const dispatch = useDispatch()
  useEffect(() => { dispatch(getPublications()) }, [dispatch])
  return <PublicationsSection />
}

export default PublicationsPage
